import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {ASSETS_QUERY_KEY} from "../queryKeys";
import {ReachAsset} from "./types";

type Variables = {};

const getAssets = async (): Promise<ReachAsset[]> => {
  const response = await axiosReachInstance.get<ReachAsset[], AxiosResponse<ReachAsset[]>>("/assets");
  return response.data;
};

export const useGetAssets = (
  variables: Variables = {},
  options?: BaseQueryOptions<ReachAsset[], Variables>
): BaseUseQueryResult<ReachAsset[]> => {
  return useBaseQuery<ReachAsset[], Variables>([ASSETS_QUERY_KEY], getAssets, variables, options);
};
